import axios from 'axios';


const BASE_URL = process.env.REACT_APP_API_URL + '/api/config';

export const getConfigurations = () => {
  return axios.get(BASE_URL);
};

export const createConfiguration = (payload) => {
  return axios.post(BASE_URL, payload);
};

export const updateConfiguration = (id, payload) => {
  return axios.put(`${BASE_URL}/${id}`, payload);
};

export const deleteConfiguration = (id) => {
  return axios.delete(`${BASE_URL}/${id}`);
};
